import _ from 'lodash'
import { useContext, useEffect, useState } from 'react'
import { Button, Dropdown, Icon, Label, Menu } from 'semantic-ui-react'
import { FrameworkContext } from '../../cnr/contexts/FrameworkContent'
import { GoogleSheetsContext } from '../../cnr/contexts/GoogleSheetsContext'
import { ParentContext } from '../../cnr/contexts/ParentContext'
import { viewDataModes } from '../../cnr/reducers/DataManagmentReducer'
import { googleSheetsTypes, googleViewTypes } from '../../cnr/reducers/GoogleSheetsReducer'
import { getUniquePropKeys } from '../../common/filtering'
import { appIconTypes } from '../../enums/appIconTypes'
import { iconColorTypes } from '../../enums/settingsIconTypes'
import { listHelpers } from '../../lists/lists'
import { createGoogleSheetKeys, validateCollectionArrays } from '../../validation/validation'
import { openExternal } from '../../viewSettings/helpers/settingsLinks'
import TransitionWrapper, { transitionWrapperTypes } from '../../wrappers/TransitionWrapper'
import Wrapper, { wrapperTypes } from '../../wrappers/Wrapper'
import WrapperVertCols from '../../wrappers/WrapperVertCols'
import UiSaveButtons from '../buttons/UiSaveButtons'
import DropdownOptionsMenu from '../forms/elements/DropdownOptionsMenu'
import DataListTable from './DataListTable'
import TreeViewer from './TreeViewer'

const ddIcons = {
  action: 'content',
  dataOptions: 'unordered list',
  updateOptions: 'unordered list',
}

const _viewTypes = {
  gs_app: 'gs_app',
  app_gs: 'app_gs',
  gs: 'gs',
}

const _menuSize = 'small'

const GoogleSheetsTabs = (props) => {

  const { handleCreate, fromCreate, _updating, setViewDataMode, googleSheetType } = props

  // parentContext
  const parentContext = useContext(ParentContext);
  const { states, fn_cls } = parentContext ?? {}
  const { currentSettings_state, paps_state, eventInfo_state } = states ?? {}
  const { pathViews } = paps_state ?? {}
  const { aps_viewItems } = _.get(currentSettings_state, 'gvviSettings', {});

  const { appDataDocuments: appDataDocuments_event } = eventInfo_state ?? {}

  // googleSheetsContext
  const frameworkContext = useContext(FrameworkContext)
  const { framework_state } = frameworkContext ?? {}
  const { frInfo, frameworkRightType } = framework_state ?? {}
  const { uivi } = frInfo ?? {}

  // googleSheetsContext
  const googleSheetsContext = useContext(GoogleSheetsContext)
  const { googleSheets_state, googleSheets_handlers } = googleSheetsContext ?? {}
  const {
    _newCounts,
    activeMenuItem,
    changedItems,
    currentCount,
    dashboardInfo_merged,
    dashboardInfo_preview_alt,
    dataCollection,
    dataCounts,
    googleActiveDataItems, // google data
    googleSheetItems,
    googleSheetsData,
    googleSheetsId,
    googleSheetsPreview,
    googleViewType,
    itemChanges,
    missingItems,
    newItems,
    result_fromGoogle,
    selectedProp,
    updating: updating_gs,
  } = googleSheets_state ?? {}

  const _activeMenuItem = activeMenuItem ? _.startCase(activeMenuItem) : null

  const props_di = googleActiveDataItems && getUniquePropKeys(googleActiveDataItems)

  const appDataLinks = googleSheetsPreview?.appDataLinks
  const appDataDocuments = googleSheetsPreview?.appDataDocuments
  const dataCollections = googleSheetsPreview?.projectData?.dataCollections
  const settings_google = googleSheetsPreview?.projectSettings
  const settings_google_app_gs = dashboardInfo_preview_alt?.previewSettings_app_gs
  const settings_google_gs_app = dashboardInfo_preview_alt?.previewSettings_gs_app
  const viewItems_gs = googleSheetsPreview?.projectSettings?.viewItems
  const gsTitle = googleSheetsPreview?.projectData?.eventData?.['1']?.name
  const props_gs = _.keys(viewItems_gs?.[uivi]?.props)

  const prpps_merged = _.union(props_di, props_gs);
  const opts = listHelpers.listList(prpps_merged)

  const _useSingleItem = frameworkRightType === 'google' ? true : false
  const viewItem = aps_viewItems[activeMenuItem]
  const _appDataDocument = appDataDocuments_event?.[activeMenuItem]

  // local state    
  const [updating, setUpdating] = useState()
  const [useItemKey, setUseItemKey] = useState()
  const [selectedKeys, setSelectedKeys] = useState()
  const [showConfirmation, setShowConfirmation] = useState()
  const [viewType, setViewType] = useState(_viewTypes.gs)

  const [_settings_google, set_settings_google] = useState(settings_google)
  const [_settings_google_gs_app, set_settings_google_gs_app] = useState(settings_google_gs_app)

  const _isUpdating = updating || updating_gs || _updating

  const handleUseItemKey = () => setUseItemKey(!useItemKey)
  const handleViewType = (vt) => setViewType(vt)
  const handleSelectedKeys = (sks) => setSelectedKeys(sks)
  const handlePropChange = (e, data) => {
    const { value } = data
    googleSheets_handlers.handleAmmend_selectedProp(value)
  }

  const markChangedItems = (dc, add) => {
    _.forEach(dc, (dataItem, key) => {
      const correspondingItem = add[key];
      if (correspondingItem && !_.isEqual(dataItem, correspondingItem)) {
        dataItem._changed = true;
      }
    });
  };

  const getBadPathsWithReasons = (obj, path = '') => {
    let issues = [];

    const currentPath = path || 'root';

    if (_.isNil(obj)) {
      issues.push({ path: currentPath, reason: obj === null ? 'Null value' : 'Undefined value' });
    } else if (_.isArray(obj)) {
      if (_.isEmpty(obj)) {
        issues.push({ path: currentPath, reason: 'Empty array' });
      } else {
        obj.forEach((item, index) => {
          issues = issues.concat(getBadPathsWithReasons(item, `${currentPath}[${index}]`));
        });
      }
    } else if (_.isPlainObject(obj)) {
      if (_.isEmpty(obj)) {
        issues.push({ path: currentPath, reason: 'Empty object' });
      } else {
        _.forEach(obj, (val, key) => {
          issues = issues.concat(getBadPathsWithReasons(val, `${currentPath}.${key}`));
        });
      }
    }

    return issues;
  };


  const openJsonInNewTab = () => {
    try {

      const bpwr = getBadPathsWithReasons(dataCollections)
      // const parsed = JSON.parse(googleSheetsPreview); // Ensure it's valid JSON
      const formatted = JSON.stringify(dataCollections, null, 2); // Pretty-print with 2-space indent

      const blob = new Blob([formatted], { type: "application/json" });
      const url = URL.createObjectURL(blob);

      window.open(url, '_blank');
    } catch (e) {
      console.error("Invalid JSON string", e);
    }
  };

  useEffect(() => {
    if (dataCollections) {
      googleSheets_handlers.handleInit_googleSheetTabs()
      setUpdating(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeMenuItem, dataCollections, _newCounts]);

  useEffect(() => {
    if (activeMenuItem) {
      googleSheets_handlers.handleInit_googleSheetActive(appDataDocuments_event)
      setUpdating(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeMenuItem]);

  // if the googleSheetItems change, update the google sheets data
  // useEffect(() => {
  //   if (googleSheetItems) {
  //     googleSheets_handlers.handle_gsAmmendments(googleSheetItems, true)
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [googleSheetItems]);

  useEffect(() => {
    if (uivi && dataCollections) {
      googleSheets_handlers.handleSet_activeMenuItem(uivi)
    }
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataCollections, uivi]);

  const handleDataCollectionChange = (dmi) => {
    setUpdating(true)
    googleSheets_handlers.handleSet_activeMenuItem(dmi)
  }

  const handleGsiClick = (e, gsi) => {
    e.stopPropagation()
    const _googleSheetItems = { ...googleSheetItems }
    _googleSheetItems[gsi].included = !_googleSheetItems[gsi].included
    // setGoogleSheetItems(_googleSheetItems)
  }

  const handle_showConfirmation = (opts) => {
    const { optionType } = opts
    setShowConfirmation(showConfirmation === optionType ? null : optionType)
  }

  const handleDatabaseOpen = () => openExternal.db(pathViews, null, [activeMenuItem])

  const handleGetGoogleSheet = () => {
    getDataFromGoogleSheets({
      gsid: googleSheetsId,
      useItemKey,
      callback: googleSheets_handlers.handleResponse_googleSheet
    })
  }

  const handleGoogleViewType = (googleViewType) => googleSheets_handlers.handleAmmend_ammendGoogleViewType(googleViewType)
  const handleOpenGoogleSheets = () => openExternal.googleSheets(googleSheetsId)

  const handleUpdateCollectionData = () => {
    googleSheets_handlers.handleStartUpdate()
    googleSheets_handlers.handleUpdate_dataCollectionsOneByOne(activeMenuItem)
  }

  const handleRecreateCollectionData = () => {
    googleSheets_handlers.handleStartUpdate()
    // collectionName, updateTheSettings, updateStaticViews, updateOnly, allowMerge, newOnly
    googleSheets_handlers.handleRecreate_dataCollectionsOneByOne(activeMenuItem, false, false, false, false)
    googleSheets_handlers.handleUpdate_dataCollectionsOneByOne(activeMenuItem)
  }

  const handleUpdateGoogleSheets = () => createGoogleSheetKeys(fn_cls, googleSheetsData, dataCollections)
  const handleValidateDataCollections = () => validateCollectionArrays(dataCollections)
  const handleViewDataMode = (opts) => setViewDataMode(opts ? opts.viewDataMode : null)

  const handlePrivate = (a, b) => {
    const _sg = { ..._settings_google_gs_app }
    const _b = b.split('.')
    if (_b.length === 4) {
      const _setting = _b[0];
      const _collection = _b[1];
      const _item = _b[2];
      const _prop = _b[3];
      if (_setting === 'viewItems' && _item === 'props') {
        if (_sg?.viewItems?.[_collection]?.props[_prop]) {
          const item = _sg.viewItems[_collection].props[_prop]
          item._isPrivate = !item._isPrivate
        }
      }
    }
    set_settings_google_gs_app(_sg)
  }

  /**
   * 
   * @param {object} data 
   * @param {boolean} hasSelectedProp 
   * @returns a TreeViewer: Data from the google sheet
   */
  const dataViewer = (data, hasSelectedProp) => {
    if (_useSingleItem || 1 === 1) {
      return <TreeViewer
        data={data}
        selectedProp={hasSelectedProp ? selectedProp : null}
        subNames={true}
        handleSelectedKeys={handleSelectedKeys}
        itemChanges={itemChanges}
        showKey={true}
        showRelations={true}
      />
    } else {
      return <DataListTable
        fixedData={googleActiveDataItems}
        viewItem={viewItem}
      />
    }
  }

  const topper = (caption, showDetails) => {

    const _text = _activeMenuItem
    const _newCount = _.size(newItems)
    const hasNew = _newCount > 0
    const _changedCount = _.size(changedItems)
    const hasChanged = _changedCount > 0
    const _missingCount = _.size(missingItems)
    const hasMissing = _missingCount > 0

    let allColor = googleViewType === googleViewTypes.all ? 'black' : 'grey'
    let newColor = googleViewType === googleViewTypes.new ? 'black' : 'grey'
    let changedColor = googleViewType === googleViewTypes.changed ? 'black' : 'grey'
    let missingColor = googleViewType === googleViewTypes.missing ? 'black' : 'grey'

    const { dcl } = currentCount ?? {}
    const _size = 'mini'

    return showDetails ?
      <div className={'topper-flex-2'}>
        <div> {_text + (' (' + caption + ')')}</div>
        <div>
          <Label size={_size} color={allColor} onClick={() => { handleGoogleViewType(googleViewTypes.all) }}>{'All  '}<Icon name='hashtag' color={'grey'} />{dcl}</Label>
          <Label size={_size} color={newColor} onClick={() => { hasNew && handleGoogleViewType(googleViewTypes.new) }}><Icon name='refresh' color={'green'} />{_newCount}</Label>
          <Label size={_size} color={changedColor} onClick={() => { hasChanged && handleGoogleViewType(googleViewTypes.changed) }}><Icon name='plus circle' color={'blue'} />{_changedCount}</Label>
          <Label size={_size} color={missingColor} onClick={() => { hasMissing && handleGoogleViewType(googleViewTypes.missing) }}><Icon name='question' color={'yellow'} />{_missingCount}</Label>
        </div>
      </div>
      :
      <div className={'topper-flex-2'}>
        <div> {_text + (' (' + caption + ')')}</div>
        <div>
          <Label size={_size} color={allColor} onClick={() => { handleGoogleViewType(googleViewTypes.all) }}>{'All  '}<Icon name='hashtag' color={'grey'} />{dcl}</Label>
        </div>
      </div>
  }

  const ddom_left = () => {
    const btns_dd = [{ caption: 'Open Database', oc: handleDatabaseOpen, icon: 'database', color: iconColorTypes.external }]
    btns_dd.push({ caption: 'Open Google Sheets', oc: handleOpenGoogleSheets, icon: appIconTypes.externalAlternate, color: iconColorTypes.external, disabled: !googleSheetsId })
    btns_dd.push({ caption: 'Refresh Google Sheets', oc: handleGetGoogleSheet, icon: appIconTypes.refresh, color: iconColorTypes.normal, disabled: !googleSheetsId })

    switch (googleSheetType) {
      case googleSheetsTypes.normal:
        btns_dd.push({ caption: 'Validate Google Sheets', oc: handleValidateDataCollections, icon: appIconTypes.refresh, color: iconColorTypes.normal, disabled: !googleSheetsId })
        btns_dd.push({ caption: 'Update Google Sheets Keys', oc: handleUpdateGoogleSheets, icon: appIconTypes.refresh, color: iconColorTypes.normal, disabled: !googleSheetsId })
        break;
      default:
      // nothing
    }
    return btns_dd.length > 0 && <DropdownOptionsMenu menuButtons={btns_dd} caption={'Actions'} icon={ddIcons.action} color={'blue'} float={'left'} />
  }

  // const buttons_solo = () => {
  //   const caption = selectedProp ? 'Update All ( ' + _.startCase(selectedProp) + ') From GS' : 'Update All From GS'
  //   const btns_dd = []
  //   btns_dd.push({ caption, oc: handle_showConfirmation, icon: appIconTypes.arrowRight, color: iconColorTypes.normal, disabled: !googleSheetsId, opts: { optionType: 'updateAll' } })
  //   return btns_dd
  // }

  const buttons_solo_confirmation = () => {
    const caption_update = selectedProp ? 'Update All (' + _.startCase(selectedProp) + ') From GS' : 'Update All!'
    const caption_recreate = selectedProp ? 'Recreate All (' + _.startCase(selectedProp) + ') From GS' : 'Recreate All'
    const btns_dd = []
    btns_dd.push({ caption: caption_recreate, oc: handleRecreateCollectionData, icon: appIconTypes.save, color: iconColorTypes.save, disabled: !googleSheetsId })
    btns_dd.push({ caption: caption_update, oc: handleUpdateCollectionData, icon: appIconTypes.save, color: iconColorTypes.save, disabled: !googleSheetsId })
    btns_dd.push({ caption: 'Cancel', oc: handle_showConfirmation, icon: appIconTypes.delete, color: iconColorTypes.remove, disabled: !googleSheetsId, fl: true })
    return <UiSaveButtons others={btns_dd} />
  }

  const buttons_top_full = () => {
    const _d = !googleSheetsPreview
    const _dm = !dashboardInfo_merged
    const _oc = handleViewDataMode
    const _icon = appIconTypes.arrowRight
    const btns = [
      { disabled: _dm, caption: _.startCase(viewDataModes.mergeDataCollections), oc: _oc, icon: _icon, opts: { viewDataMode: viewDataModes.mergeDataCollections, commitType: viewDataModes.mergeDataCollections } },
      { disabled: _d, caption: _.startCase(viewDataModes.mergeSettings), oc: _oc, icon: _icon, opts: { viewDataMode: viewDataModes.mergeSettings } },
      { disabled: _d, caption: _.startCase(viewDataModes.mergeDataAndSettings), oc: _oc, icon: _icon, opts: { viewDataMode: viewDataModes.mergeDataAndSettings } },

      { disabled: _d, caption: _.startCase(viewDataModes.recreateDataCollections), oc: _oc, icon: _icon, opts: { viewDataMode: viewDataModes.recreateDataCollections, commitType: viewDataModes.recreateDataCollections } },
      { disabled: _d, caption: _.startCase(viewDataModes.recreateSettings), oc: _oc, icon: _icon, opts: { viewDataMode: viewDataModes.recreateSettings } },
      { disabled: _d, caption: _.startCase(viewDataModes.recreateDataAndSettings), oc: _oc, icon: _icon, opts: { viewDataMode: viewDataModes.recreateDataAndSettings } },
      // { disabled: _d, caption: _.startCase(viewDataModes.recreateDataDocuments), oc: _oc, icon: _icon, opts: { viewDataMode: viewDataModes.recreateDataDocuments, commitType: viewDataModes.recreateDataDocuments } },
      { disabled: _d, caption: _.startCase(viewDataModes.recreateGlobalSettings), oc: _oc, icon: _icon, opts: { viewDataMode: viewDataModes.recreateGlobalSettings } },
    ]

    return <DropdownOptionsMenu menuButtons={btns} caption={'Data and Settings Options'} color={'blue'} icon={ddIcons.dataOptions} direction={'left'} />

  }

  const buttons_footer_single = () => {
    const _oc = handleViewDataMode
    const _icon = appIconTypes.arrowRight
    const btns = []
    btns.push({ caption: _.startCase(viewDataModes.addNewDataCollection), oc: _oc, icon: _icon, disabled: !activeMenuItem, opts: { viewDataMode: viewDataModes.addNewDataCollection, commitType: viewDataModes.addNewDataCollection } })
    btns.push({ caption: _.startCase(viewDataModes.recreateDataCollection), oc: _oc, icon: _icon, disabled: !activeMenuItem, opts: { viewDataMode: viewDataModes.recreateDataCollection, commitType: viewDataModes.recreateDataCollection } })
    btns.push({ caption: _.startCase(viewDataModes.mergeDataCollection), oc: _oc, icon: _icon, disabled: !activeMenuItem, opts: { viewDataMode: viewDataModes.mergeDataCollection, commitType: viewDataModes.mergeDataCollection } })
    return <DropdownOptionsMenu menuButtons={btns} caption={'Data Options (' + _activeMenuItem + ')'} color={'blue'} icon={ddIcons.dataOptions} direction={'left'} />
  }

  const buttons_footer_create = () => {
    const _oc = handleViewDataMode
    const _icon = appIconTypes.arrowRight
    const btns = []
    btns.push({ caption: _.startCase(viewDataModes.createEvent), oc: handleCreate, icon: _icon, disabled: !activeMenuItem, opts: { viewDataMode: viewDataModes.createEvent } })
    btns.push({ caption: _.startCase(viewDataModes.createEvent_limited), oc: handleCreate, icon: _icon, disabled: !activeMenuItem, opts: { viewDataMode: viewDataModes.createEvent_limited } })
    btns.push({ caption: _.startCase(viewDataModes.createGsEvent), oc: handleCreate, icon: _icon, disabled: !activeMenuItem, opts: { viewDataMode: viewDataModes.createGsEvent } })
    btns.push({ caption: _.startCase(viewDataModes.recreateEvent), oc: handleCreate, icon: _icon, disabled: !activeMenuItem, opts: { viewDataMode: viewDataModes.recreateEvent } })
    btns.push({ caption: _.startCase('viewJson'), oc: openJsonInNewTab, icon: 'eye' })
    return <DropdownOptionsMenu menuButtons={btns} caption={'Create Options'} color={'blue'} icon={ddIcons.dataOptions} direction={'left'} />
  }

  const footer_main = () => <div>
    {ddom_left()}
    {buttons_footer_single()}
  </div>

  const footer_create = () => <div>
    {buttons_footer_create()}
  </div>

  const content_confirmation = () => {
    let caption = 'Are you sure you want to ' + _.startCase(showConfirmation) + '?'
    if (selectedProp) {
      caption += ' (' + _.startCase(selectedProp) + ')'
    }
    return <Wrapper
      header={'Confirmation'}
      content={caption}
      footer={buttons_solo_confirmation()}
      wrapperType={wrapperTypes.padded}
    />
  }

  const wrapper_data_google = (data, caption) => <Wrapper
    header={topper(caption, true)}
    search={<Dropdown
      options={opts}
      placeholder='Select Prop'
      fluid
      selection
      style={{ margin: '1em 0' }}
      onChange={handlePropChange}
    />
    }
    content={<TransitionWrapper key={activeMenuItem} transitionWrapperType={transitionWrapperTypes.fade}>
      {dataCollection && dataViewer(_.orderBy(data, ['lastName', 'name']), true)}
    </TransitionWrapper>}
    wrapperType={wrapperTypes.paddedHeader}
    updating={_isUpdating}
  />

  const wrapper_data_app = (data, caption) => <Wrapper
    header={topper(caption)}
    search={_appDataDocument && data && <Dropdown
      options={opts}
      placeholder='Select Prop'
      fluid
      selection
      style={{ margin: '1em 0' }}
      onChange={handlePropChange}
    />
    }
    content={<TransitionWrapper key={activeMenuItem} transitionWrapperType={transitionWrapperTypes.fade}>
      {_appDataDocument && data ? dataViewer(_.orderBy(data, ['lastName', 'name'])) : <div style={{ padding: '1em' }}>No Data</div>}
    </TransitionWrapper>}
    wrapperType={wrapperTypes.paddedHeader}
    updating={_isUpdating}
  />

  const menu_data_app = () => activeMenuItem ? wrapper_data_app(_appDataDocument, 'App') : <div className='cntr fw-b'></div>

  const menu_data_google = () => activeMenuItem && dataCollection ? wrapper_data_google(googleActiveDataItems, 'GS') : <div className='cntr fw-b'></div>

  const header_prod = () => <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
    <div>{_.startCase('Settings')}</div>
    <div>
      <Button.Group floated='right' size='mini' color='blue'>
        <Button active={viewType === _viewTypes.gs} onClick={() => { handleViewType(_viewTypes.gs) }}>{_.startCase(_viewTypes.gs)}</Button>
        <Button active={viewType === _viewTypes.gs_app} onClick={() => { handleViewType(_viewTypes.gs_app) }}>{_.startCase(_viewTypes.gs_app)}</Button>
        <Button active={viewType === _viewTypes.app_gs} onClick={() => { handleViewType(_viewTypes.app_gs) }}>{_.startCase(_viewTypes.app_gs)}</Button>
      </Button.Group>
    </div>
  </div>

  const menu_text = (key) => {
    const _text = _.startCase(key)
    const _dataCount = dataCounts ? dataCounts[key] : {}
    const { newCount } = _dataCount ?? {}
    return <div className={newCount > 0 ? 'gsin' : null}>{_text}</div>
  }

  const menu_vert_googleTabs = () => {
    const _googleSheetItems = _.orderBy(googleSheetItems, ['lastName', 'firstName', 'name'])
    const _mis = _googleSheetItems ? _googleSheetItems.map(gsi => (
      <Menu.Item
        onClick={() => { handleDataCollectionChange(gsi.key) }}
        className={activeMenuItem === gsi.key ? 'sel' : null}
      >
        {menu_text(gsi.name)}
        <div>
          <Icon name={'check circle'} style={{ float: 'right' }} color={gsi.included ? 'green' : 'grey'} onClick={(e) => { handleGsiClick(e, gsi.key) }} />
        </div>
      </Menu.Item>)) : []

    return <Wrapper
      header={_.startCase('Google Sheets Tabs')}
      content={<Menu vertical secondary size={_menuSize} className='menu-vert-col'>{_mis}</Menu>}
      wrapperType={wrapperTypes.paddedHeaderAndFooter}
    />
  }

  const wrapper_googleEventData = () => <Wrapper
    header={_.startCase('Google Event Data')}
    content={<TreeViewer data={googleSheetsPreview?.projectData?.eventData} scNames={true} subNames={true} />}
    wrapperType={wrapperTypes.paddedHeaderAndFooter}
  />

  const wrapper_googleData = () => <Wrapper
    header={_.startCase('Google Data')}
    content={<TreeViewer data={googleSheetsPreview?.projectData?.dataCollections} scNames={true} subNames={true} showKey={true} />}
    wrapperType={wrapperTypes.paddedHeaderAndFooter}
  />

  const wrapper_googleResults = () => <Wrapper
    header={_.startCase('Google Results')}
    content={<TreeViewer data={result_fromGoogle} scNames={true} subNames={true} />}
    wrapperType={wrapperTypes.paddedHeaderAndFooter}
  />

  const wrapper_appDataLinks = () => <Wrapper
    header={_.startCase('appDataLinks')}
    content={<TreeViewer data={appDataLinks} scNames={true} subNames={true} />}
    wrapperType={wrapperTypes.paddedHeaderAndFooter}
  />

  const wrapper_appDataDocuments = () => <Wrapper
    header={_.startCase('appDataDocuments')}
    content={<TreeViewer data={appDataDocuments} scNames={true} subNames={true} />}
    wrapperType={wrapperTypes.paddedHeaderAndFooter}
  />

  const wrapper_settings = () => {
    let tvData = {};
    switch (viewType) {
      case _viewTypes.gs:
        tvData = _settings_google
        break;
      case _viewTypes.gs_app:
        tvData = _settings_google_gs_app
        break;
      case _viewTypes.app_gs:
        tvData = settings_google_app_gs
        break;
      default:
        tvData = _settings_google
    }

    if (fromCreate) {
      tvData = _settings_google_gs_app
    }

    return <Wrapper
      header={fromCreate ? 'Settings' : header_prod()}
      content={<TreeViewer data={tvData} subNames={false} scNames={true} handlePrivate={handlePrivate} />}
      wrapperType={wrapperTypes.paddedHeader}
    />
  }

  /**
   * 
   * @returns WVC: four columns (Tabs, Settings, App Data, Google Data)
   */
  const menuContent = () => <WrapperVertCols mvc={_useSingleItem ? null : '4'}>
    {!_useSingleItem && menu_vert_googleTabs()}
    {wrapper_settings()}
    {showConfirmation ? content_confirmation() : menu_data_app()}
    {showConfirmation ? content_confirmation() : menu_data_google()}
  </WrapperVertCols>


  const menuContent_create = () => <WrapperVertCols mvc={'5'}>
    {wrapper_googleResults()}
    {wrapper_settings()}
    {wrapper_googleData()}
    {wrapper_appDataLinks()}
    {wrapper_appDataDocuments()}
  </WrapperVertCols>

  const header_create = () => <div>{gsTitle || 'Missing Event Name'}</div>

  const footer_wrapper = () => {
    if (fromCreate) {
      return footer_create()
    } else {
      return footer_main()
    }
  }

  const wrapper = () => <Wrapper
    header={!_useSingleItem && !fromCreate ? buttons_top_full() : header_create()}
    content={fromCreate ? menuContent_create() : menuContent()}
    footer={((!_useSingleItem && activeMenuItem) || fromCreate) && footer_wrapper()}
    wrapperType={wrapperTypes.paddedHeader}
    updating={_isUpdating}
    noMid={!_useSingleItem}
  />

  return wrapper()

}

export default GoogleSheetsTabs

